import { ListItemIcon } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import SettingsIcon from "@material-ui/icons/Settings";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { showSidebar } from "../../../redux/actions/sidebarActions";

export default function Settings() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <ListItem
      button
      onClick={() => {
        history.push("/settings");
        dispatch(showSidebar(false));
      }}
    >
      <ListItemIcon>
        <SettingsIcon />
      </ListItemIcon>
      <ListItemText primary={t("mainSideBar.settings")} />
    </ListItem>
  );
}
